export default "__VITE_ASSET__C4Wn4C75__"